import axios from "axios";

/** Returns true if the error is a cancelled/aborted request. */
export const isCancelled = (error: unknown): boolean => axios.isCancel(error);

/** Returns the HTTP status code from an Axios error, -1 if cancelled, or 502 if unavailable. */
export const getErrorCode = (error: unknown): number => {
  if (isCancelled(error)) return 0;
  if (!axios.isAxiosError(error)) return 500;
  const response = error.response;
  if (!response) return 502;
  return response?.status ?? 502;
};

/** Returns the response data from an Axios error, or undefined if unavailable. */
export const getErrorData = <T = unknown>(error: unknown): T | undefined => {
  if (!axios.isAxiosError(error)) return undefined;
  const response = error.response;
  if (!response) return undefined;
  return response?.data as T;
};

export const getRequestUrl = (error: unknown): string | undefined => {
  if (!axios.isAxiosError(error)) return undefined;
  const config = error.config;
  if (!config) return undefined;
  const method = config.method?.toUpperCase();
  return `${method} ${config.url}`;
};
